/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { CluMigrationJobStore } from 'src/clu/core/stores/CluMigrationJobStore';
import { LuisMigratedAppStore } from 'src/clu/core/stores/LuisMigratedAppStore';
import { OmitFunctions } from 'src/core/stores/types';
import { LuisAppStore } from 'src/luis/core/stores/LuisAppStore';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';

export type CluMigrationStoreData = OmitFunctions<Omit<Partial<CluMigrationStore>, 'id'>>;

export class CluMigrationStore {
    public luisMigratedAppsStoreHouse = createResourceStoreHouse<LuisMigratedAppStore>();

    public cluMigrationJobsStoreHouse = createResourceStoreHouse<CluMigrationJobStore>();

    @observable public selectedApps: LuisAppStore[] = [];

    @action
    public setSelectedApps(selectedApps: LuisAppStore[]) {
        this.selectedApps = [...selectedApps];
    }
}
